var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mytag"},[_c('span',{staticClass:"left"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.type))])])
}
var staticRenderFns = []

export { render, staticRenderFns }